import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';
import { stopJoyride } from '../../store/modules/options';

const mapActionCreators = {
  stopJoyride,
};

const mapStateToProps = state => ({
  runJoyride: state.options.runJoyride,
});

class JoyRideStaff extends React.Component {
  joyrideCallback = event => {
    if (event.action === 'close') {
      // this.props.stopJoyride();
    } else if (event.action === 'skip') {
      this.props.stopJoyride();
    }
  };

  render() {
    if (typeof this.props.runJoyride === 'undefined') {
      return null;
    }

    const joyrideSteps = [
      {
        title: 'Ihre Mitarbeiter',
        text:
          'Hier können Sie all Ihre Mitarbeiter einpflegen - Auch solche die keinen Zugriff zu SiMPL erhalten sollen.',
        selector: '.JoyrideStaff',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
      {
        title: 'Zur Benutzerverwaltung',
        text:
          'An dieser Stelle können Sie Benutzer aus der Anwendung entfernen bzw. sie einladen.',
        selector: '.JoyrideStaffLink',
        position: 'top',
        type: 'hover',
        allowClicksThruHole: true,
        isFixed: true,
        style: {
          width: '29rem',
          beacon: {
            offsetY: 0,
          },
        },
      },
    ];

    return (
      <Joyride
        ref="joyride-activity"
        steps={joyrideSteps}
        run={this.props.runJoyride} // or some other boolean for when you want to start it
        // debug={__DEV__}
        showSkipButton
        showStepsProgress
        type="continuous"
        callback={this.joyrideCallback}
        locale={{
          back: 'Zurück',
          close: 'Schließen',
          last: 'Schließen',
          next: 'Weiter',
          skip: 'Tutorial beenden',
        }}
      />
    );
  }
}
JoyRideStaff.propTypes = {
  runJoyride: PropTypes.bool.isRequired,
  stopJoyride: PropTypes.func.isRequired,
};
JoyRideStaff.defaultProps = {
  runJoyride: false,
};
export default connect(mapStateToProps, mapActionCreators)(JoyRideStaff);



// WEBPACK FOOTER //
// ./src/components/JoyRideStaff/JoyRideStaff.js